import { IVENTIS_LOGO } from "@iventis/utilities";
import React, { FunctionComponent } from "react";
import { styled } from "@iventis/styles";

export const SiteLogoComponent: FunctionComponent<{ className?: string; logoUrl?: string }> = ({ className, logoUrl }) => (
    <StyledLogo className={className} data-testid="logo" id="logo-small" src={logoUrl ?? IVENTIS_LOGO} alt="Company logo" />
);

const StyledLogo = styled.img`
    display: flex;
    max-width: 45%;
    min-width: 159px;
    margin: auto;
    margin-bottom: 5%;
    margin-top: 8%;
`;
